module.exports = __webpack_public_path__ + "static/media/care_in_hospital_map.4f9f7432.svg";